module.exports = __webpack_public_path__ + "static/media/alarm.441ae586.svg";